// src/Stateview/AchievementTable.js
import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import axios from 'axios';
import './AchievementTable.css';

const AchievementTable = ({ filters }) => {
  const [data, setData] = useState([]);

  const fetchAchievementData = () => {
    const query = new URLSearchParams(filters).toString();
    axios
      .get(`https://api-usersreport-insights.haqdarshak.com/api/opsco-achievements?${query}`)
      .then((res) => setData(res.data))
      .catch((err) => console.error('Error fetching achievement data:', err));
  };

  useEffect(() => {
    fetchAchievementData();
  }, [filters]); // refetch when filters change

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Opscos and HDs');
    XLSX.writeFile(workbook, 'Statewise_Opscos_and_HDs.xlsx');
  };

  return (
    <div className="opsco-table-container">
      <h2 className="opsco-table-title">Statewise Opscos and HDs</h2>
      <button onClick={exportToExcel} className="export-btn">Export to Excel</button>
      <div className="opsco-scroll-container">
        <table className="opsco-achievement-table">
          <thead>
            <tr>
              <th className="opsco-sticky-header opsco-sticky-left">State</th>
              <th>Delivery Head</th>
              <th>Delivery Lead</th>
              <th>Lead PM</th>
              <th>State PM</th>
              <th>PM</th>
              <th>Coordinator</th>
              <th>Fellow</th>
              <th>Active Haqdarshak</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td className="opsco-sticky-left">{row.State}</td>
                <td>{row['Delivery Head']}</td>
                <td>{row['Delivery Lead']}</td>
                <td>{row['Lead PM']}</td>
                <td>{row['State PM']}</td>
                <td>{row['PM']}</td>
                <td>{row['Coordinator']}</td>
                <td>{row['Fellow']}</td>
                <td>{row['Active Haqdarshak']}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AchievementTable;
